import { FileTextOutlined } from '@ant-design/icons'

import { RouteItem } from '@eastcoal/router/types/route'

import { ORDER_LIST_PAGE_PATH } from './constant/path'
import { ORDER_PAGE_UUID } from './constant/uuid'

export const orderRoute: RouteItem = {
  title: '订单列表',
  uuid: ORDER_PAGE_UUID,
  path: ORDER_LIST_PAGE_PATH,
  icon: <FileTextOutlined />,
  Component: () => import('./index')
}
